var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.6688C0 15.8912 15.2222 0.668945 33.9999 0.668945C52.7775 0.668945 67.9997 15.8912 67.9997 34.6688C67.9997 53.4464 52.7775 68.6686 33.9999 68.6686C15.2222 68.6686 0 53.4464 0 34.6688Z",
    fill: "#B32F2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0754 30.7158C45.0754 30.7158 44.2277 41.2298 43.736 45.6586C43.5018 47.7739 42.1952 49.0135 40.0549 49.0525C35.982 49.1258 31.9044 49.1305 27.8331 49.0447C25.774 49.0025 24.4892 47.7474 24.2597 45.6696C23.7649 41.2017 22.9219 30.7158 22.9219 30.7158",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2368 25.6761H20.7637",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1366 25.6752C40.9111 25.6752 39.8558 24.8088 39.6154 23.6083L39.236 21.71C39.0019 20.8342 38.2088 20.2285 37.305 20.2285H30.6968C29.793 20.2285 28.9999 20.8342 28.7658 21.71L28.3864 23.6083C28.146 24.8088 27.0907 25.6752 25.8652 25.6752",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemove);
export default __webpack_public_path__ + "static/media/icon-remove.8e8401e315508c25c9676c23c6d75a1b.svg";
export { ForwardRef as ReactComponent };